import { Colors, Services } from '@sigma-frontend-libs/commons'
import { MODERATION_VALUES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons, labelModes, popperPlacements } from '@/utils'

import button from '@/components/button'

function renderProviderSelect(h) {
  return h(
    components.select,
    {
      props: {
        value: this.providerId,
        service: Services.providers,
        query: { isActive: true },
        label: this.getTranslate(`${Services.sendingsModeration}.labels.defaultRoute`),
        labelMode: labelModes.hidden,
        dense: true,
        clearable: true,
        autocomplete: true,
        details: false,
        disabled: this.disabled
      },
      on: {
        input: event => {
          this.providerId = event
        }
      }
    }
  )
}

function renderInfoButton(h) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        color: Colors.grey,
        icon: icons.question_mark,
        tooltip: this.getTranslate(`${Services.sendingsModeration}.tooltips.info`)
      }
    }
  )
}
function renderApproveButton(h) {
  let approveIcon
  let approveTooltip
  if (this.massive) {
    approveIcon = icons.done_all
    approveTooltip = this.getTranslate(`${Services.sendingsModeration}.actions.massive.approved`)
  } else {
    approveIcon = icons.done
    approveTooltip = this.getTranslate(`${Services.sendingsModeration}.actions.approved`)
  }

  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: approveIcon,
        color: Colors.success,
        loading: this.loading,
        disabled: this.disabled,
        tooltip: approveTooltip
      },
      on: {
        click: () => {
          this.createTask(MODERATION_VALUES.approved)
        }
      }
    }
  )
}
function renderRejectButton(h) {
  let rejectTooltip
  if (this.massive) {
    rejectTooltip = this.getTranslate(`${Services.sendingsModeration}.actions.massive.rejected`)
  } else {
    rejectTooltip = this.getTranslate(`${Services.sendingsModeration}.actions.rejected`)
  }

  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: this.icon.rejected.icon,
        color: this.icon.rejected.color,
        loading: this.loading,
        disabled: this.disabled,
        tooltip: rejectTooltip
      },
      slot: 'activator'
    }
  )
}

function renderRejectMenuListItem(h, action) {
  let itemLabel
  if (this.massive) {
    itemLabel = this.getTranslate(`${Services.sendingsModeration}.actions.massive.${action}`)
  } else {
    itemLabel = this.getTranslate(`${Services.sendingsModeration}.actions.${action}`)
  }

  let refund
  if (action === 'rejectedRefound') {
    refund = true
  }

  return h(
    components['list-item'],
    {
      props: {
        icon: this.icon[action].icon,
        iconColor: this.icon[action].color,
        label: itemLabel,
        dense: true
      },
      on: {
        click: () => {
          this.createTask(MODERATION_VALUES.rejected, refund)
        }
      }
    }
  )
}
function renderRejectMenuList(h) {
  return h(
    components.list,
    {
      props: {
        dense: true,
        rounded: true
      }
    },
    [
      renderRejectMenuListItem.call(this, h, 'rejected'),
      renderRejectMenuListItem.call(this, h, 'rejectedRefound')
    ]
  )
}
function renderRejectMenu(h) {
  let rejectMenuWidth
  if (this.massive) {
    rejectMenuWidth = 260
  } else {
    rejectMenuWidth = 225
  }

  return h(
    components.menu,
    {
      props: {
        value: this.showRejectMenu,
        rounded: true,
        offsetDistance: 8,
        placement: popperPlacements['bottom-end'],
        disabled: this.disabled,
        width: rejectMenuWidth
      },
      on: {
        input: event => {
          this.showRejectMenu = event
        }
      }
    },
    [
      renderRejectButton.call(this, h),
      renderRejectMenuList.call(this, h)
    ]
  )
}

function renderButtons(h) {
  return [
    renderProviderSelect.call(this, h),

    h(
      'div',
      {
        class: {
          [`${Services.sendingsModeration}-actions__buttons`]: true,
          'hover-child': !this.showRejectMenu
        }
      },
      [
        renderInfoButton.call(this, h),
        renderApproveButton.call(this, h),
        renderRejectMenu.call(this, h)
      ]
    )
  ]
}

function renderApproveMenuItem(h) {
  return h(
    components['list-item'],
    {
      props: {
        icon: icons.done,
        iconColor: Colors.success,
        label: this.getTranslate(`${Services.sendingsModeration}.actions.approved`),
        disabled: this.disabled,
        dense: true
      },
      on: {
        click: () => {
          this.createTask(MODERATION_VALUES.approved)
        }
      }
    }
  )
}

function renderMenu(h) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        offsetDistance: 8,
        placement: popperPlacements['bottom-end'],
        closeOnContentClick: false,
        width: 250
      }
    },
    [
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            icon: icons.more_vert
          },
          slot: 'activator'
        }
      ),

      h(
        'div',
        {
          class: 'fc pt-2 pb-1'
        },
        [
          h(
            'div',
            {
              class: 'px-2 pb-1'
            },
            [ renderProviderSelect.call(this, h) ]
          ),
          renderApproveMenuItem.call(this, h),
          renderRejectMenuList.call(this, h)
        ]
      )
    ]
  )
}

function renderContentByViewport(h) {
  if (this.viewport.size.width >= 1920 || this.massive) {
    return renderButtons.call(this, h)
  } else {
    return renderMenu.call(this, h)
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.sendingsModeration}-actions`]: true,
        [`${Services.sendingsModeration}-actions--massive`]: this.massive
      }
    },
    [ renderContentByViewport.call(this, h) ]
  )
}

